import { useAct } from 'FlowBuilder/store'
import CodeMirrorEditor from 'Shared/components/CodeMirrorEditor'

export default function AdvancedSettingsForm() {
  const act = useAct()
  
  const {additionalHead, additionalCss} = useSel(s => s.builder?.flow || {})

  return (
    <form>
      <div className="field margin-top">
        <label className="margin-bottom half">Additional Head HTML</label>
        <CodeMirrorEditor
          value={additionalHead}
          onChange={(value) => act.builder.updateFlow('additionalHead', value)}
          mode='html'
        />
      </div>

      <div className="field margin-top">
        <label className="margin-bottom half">Additional Style CSS</label>
        <CodeMirrorEditor
          value={additionalCss}
          onChange={(value) => act.builder.updateFlow('additionalCss', value)}
          mode='css'
        />
      </div>
    </form>
  )
}
